import Signal from 'vegas-js-signals/src/Signal'

const reloader = new Signal() ;

export default reloader ;